module.exports = "<div class='memo-note'>\n    <p ng-transclude></p>\n</div>x\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/blocks/notes/notes.partial.html
// module id = 93
// module chunks = 0